class NewsLetterSignup {
    constructor() {
       this.NewsLetterSignup();
    }

    NewsLetterSignup() {
        var url_string = window.location.href; //window.location.href
        var url = new URL(url_string);
        var c = url.searchParams.get("tfa_next");
        if ( c != null ) {
            var height = $('.theme-header').height() + 100;
            setTimeout( () => {
                jQuery("html, body").animate({
                    scrollTop: jQuery( '#newsletter-signup-b' ).offset().top - height
                }, 700);
            }, 200 );
        }
    }
}

export default NewsLetterSignup;
new NewsLetterSignup();
